<template>
  <div class="xiangqing">
    <van-popup
      v-model="isShowShare"
      round
      position="bottom"
      :style="{ height: 'auto' }"
      ><div class="shareWayList">
        <div class="everyShare" @click="shareWx">
          <div class="inEveryShare">
            <div class="shareIcon">
              <img src="../assets/images/weixinIcon.png" alt="" />
            </div>
            <div class="shareName">微信好友</div>
          </div>
        </div>
        <div class="everyShare" @click="shareWxfriend">
          <div class="inEveryShare">
            <div class="shareIcon">
              <img src="../assets/images/friendIcon.png" alt="" />
            </div>
            <div class="shareName">朋友圈</div>
          </div>
        </div>
        <div class="everyShare" @click="shareWeibo">
          <div class="inEveryShare">
            <div class="shareIcon">
              <img src="../assets/images/weiboIcon.png" alt="" />
            </div>
            <div class="shareName">微博</div>
          </div>
        </div>
        <div class="everyShare" @click="shareQQfriend">
          <div class="inEveryShare">
            <div class="shareIcon">
              <img src="../assets/images/qqIcon.png" alt="" />
            </div>
            <div class="shareName">QQ好友</div>
          </div>
        </div>

        <div class="everyShare twoEveryShare" @click="shareQzone">
          <div class="inEveryShare">
            <div class="shareIcon">
              <img src="../assets/images/qzoneIcon.png" alt="" />
            </div>
            <div class="shareName">QQ空间</div>
          </div>
        </div>
        <div class="everyShare" @click="refresh">
          <div class="inEveryShare">
            <div class="shareIcon">
              <img src="../assets/images/refreshIcon.png" alt="" />
            </div>
            <div class="shareName">刷新</div>
          </div>
        </div>
      </div>
      <div class="fenge"></div>
      <div class="dibuQuxiao" @click="noShare">
        <div class="word">取消</div>
      </div></van-popup
    >
    <div class="xiangqingContainer">
      <div class="content1">
        <div class="picLunbo">
          <van-swipe @change="onchange">
            <van-swipe-item
              v-for="(item, index) in inContent.pictureList"
              :key="index"
              ><img :src="item.pictureurl" alt="" preview="index"
            /></van-swipe-item>
            <template #indicator>
              <div class="custom-indicator">
                {{ current + 1 }}/{{ interaction.picturecount }}
              </div>
            </template>
          </van-swipe>
        </div>
        <div class="word">{{ interaction.content }}</div>
        <div class="addr" v-if="interaction.hasOwnProperty('position')">
          <img src="../assets/images/dingwei.svg" alt="" />
          <div class="addrWord">{{ interaction.position }}</div>
        </div>
        <div class="date">{{ interaction.createtime }}</div>
      </div>
      <div class="fenge"></div>
      <div class="content2">
        <div class="Seldianzan">
          <div class="pinlun active">
            <div class="word">
              评论 <span>{{ interaction.commentcount }}</span>
            </div>
            <div class="xiahuaxian"></div>
          </div>
          <div class="pinlun">
            <div class="word">
              点赞 <span>{{ interaction.fabulouscount }}</span>
            </div>
          </div>
        </div>
        <div class="noPinlun" v-if="commentList.length == 0">
          <div class="inNopinlun">
            <div class="nopinlunimg">
              <img src="../assets/images/nopinlun.png" alt="" />
            </div>
            <div class="word">成为第一个评论的人吧</div>
          </div>
        </div>
        <div class="pinlunList" v-if="!commentList.length == 0">
          <div class="InPinlunList" v-for="item in commentList" :key="item.id">
            <div class="touxiang">
              <img :src="item.headimg" alt="" v-if="!item.headimg == ''" />
              <img
                src="../assets/images/nohead.png"
                alt=""
                v-if="item.headimg == ''"
              />
            </div>
            <div class="listContent">
              <div class="xinxi">
                <div class="phoneNum">{{ item.phone }}</div>
                <div class="date">{{ item.createtime }}</div>
              </div>
              <div class="pinlunContent">{{ item.content }}</div>
            </div>
          </div>
        </div>
        <div class="dibu1" v-show="isDianzanShow">
          <div class="shurukuang" @click="goPinlun">
            <img src="../assets/images/newpinlun.png" alt="" />

            <div class="word">添加评论</div>
          </div>
          <div
            class="dibuDianzan"
            @click="
              dianzan(
                inContent.isFabulous,
                !inContent.hasOwnProperty('isFabulous')
              )
            "
          >
            <img
              src="../assets/images/pinllunzan.png"
              alt=""
              v-show="
                inContent.isFabulous == 0 ||
                !inContent.hasOwnProperty('isFabulous')
              "
            />
            <img
              src="../assets/images/dianzan2.png"
              alt=""
              v-show="inContent.isFabulous == 1"
            />

            <div class="dianzanWord">点赞</div>
          </div>
          <div class="share" @click="showShare">
            <img src="../assets/images/shareBtn.png" alt="" />
          </div>
        </div>
        <van-popup
          v-model="isPinlunShow"
          round
          position="bottom"
          :style="{ height: 'auto' }"
          @click-overlay="showDianzan"
        >
          <div class="dibu2">
            <input
              type="text"
              placeholder="添加评论"
              @blur="goDianzan"
              v-model="pinlunContent"
            />
            <div class="fabuWord" @click="fabuPinlun">发布</div>
          </div>
        </van-popup>
      </div>
    </div>
  </div>
</template>

<script>
import { doRem } from "../utils/setrem";
import Vue from "vue";
import { Swipe, SwipeItem } from "vant";
import { Field } from "vant";
import { Overlay } from "vant";
import { Popup } from "vant";
import qs from "qs";
import { Dialog } from "vant";
import { Toast } from "vant";
import bridge from "../common/bridge";
import preview from "vue-photo-preview";
import "vue-photo-preview/dist/skin.css";
Vue.use(preview);

Vue.use(Popup);

Vue.use(Overlay);

Vue.use(Field);

Vue.use(Swipe);
Vue.use(SwipeItem);
export default {
  mounted() {


    this.getContent();
    this.src =
      this.$axios.defaults.baseURL +
      "llt-app-html" +
      "/ShareHudong" +
      `?id=${this.$route.query.id}`;
  },
  data() {
    return {
      current: 0,
      isShowShare: false,
      isDianzanShow: true,
      isPinlunShow: false,
      isPinlunSel: true,
      isDianzanSel: false,
      inContent: Object,
      interaction: Object,
      commentList: [],
      pinlunContent: "",
      title: "失物招领",
      neirong: "一个App畅享全市政务服务",
      src: "",
      type1: "wxhy",
      type2: "wxpyq",
      type3: "wb",
      type4: "qqhy",
      type5: "qqkj",
    };
  },
  methods: {
    shareWx() {
      let ua = navigator.userAgent;
      let isAndroid = ua.indexOf("Android") > -1 || ua.indexOf("Adr") > -1;
      let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      let data = {
        src: this.src,
        title: this.title,
        content: this.neirong,
        type: this.type1,
      };
      let data2 = JSON.stringify(data);
      if (isiOS) {
        bridge.callhandler("shareMessage", data2, (data) => {
          // 处理返回数据
          console.log(data);
        });
      }
      if (isAndroid) {
        var str = JSON.parse(
          window.ServiceAddrInterface.shareMessage(
            this.src,
            this.title,
            this.neirong,
            this.type1
          )
        );
      }
    },
    shareWxfriend() {
      let ua = navigator.userAgent;
      let isAndroid = ua.indexOf("Android") > -1 || ua.indexOf("Adr") > -1;
      let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      let data = {
        src: this.src,
        title: this.title,
        content: this.neirong,
        type: this.type2,
      };
      let data2 = JSON.stringify(data);
      if (isiOS) {
        bridge.callhandler("shareMessage", data2, (data) => {
          // 处理返回数据
          console.log(data);
        });
      }
      if (isAndroid) {
        var str = JSON.parse(
          window.ServiceAddrInterface.shareMessage(
            this.src,
            this.title,
            this.neirong,
            this.type2
          )
        );
      }
    },
    shareWeibo() {
      let ua = navigator.userAgent;
      let isAndroid = ua.indexOf("Android") > -1 || ua.indexOf("Adr") > -1;
      let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      let data = {
        src: this.src,
        title: this.title,
        content: this.neirong,
        type: this.type3,
      };
      let data2 = JSON.stringify(data);
      if (isiOS) {
        bridge.callhandler("shareMessage", data2, (data) => {
          // 处理返回数据
          console.log(data);
        });
      }
      if (isAndroid) {
        var str = JSON.parse(
          window.ServiceAddrInterface.shareMessage(
            this.src,
            this.title,
            this.neirong,
            this.type3
          )
        );
      }
    },
    shareQQfriend() {
      let ua = navigator.userAgent;
      let isAndroid = ua.indexOf("Android") > -1 || ua.indexOf("Adr") > -1;
      let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      let data = {
        src: this.src,
        title: this.title,
        content: this.neirong,
        type: "qq",
      };
      let data2 = JSON.stringify(data);
      if (isiOS) {
        bridge.callhandler("shareMessage", data2, (data) => {
          // 处理返回数据
          console.log(data);
        });
      }

      if (isAndroid) {
        var str = JSON.parse(
          window.ServiceAddrInterface.shareMessage(
            this.src,
            this.title,
            this.neirong,
            this.type4
          )
        );
      }
    },
    shareQzone() {
      let ua = navigator.userAgent;
      let isAndroid = ua.indexOf("Android") > -1 || ua.indexOf("Adr") > -1;
      let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      let data = {
        src: this.src,
        title: this.title,
        content: this.neirong,
        type: this.type5,
      };
      let data2 = JSON.stringify(data);
      if (isiOS) {
        bridge.callhandler("shareMessage", data2, (data) => {
          // 处理返回数据
          console.log(data);
        });
      }
      if (isAndroid) {
        var str = JSON.parse(
          window.ServiceAddrInterface.shareMessage(
            this.src,
            this.title,
            this.neirong,
            this.type5
          )
        );
      }
    },
    refresh() {
      location.reload();
    },
    onchange(index) {
      this.current = index;
    },

    fabuPinlun() {
      if (this.pinlunContent == "") {
        Dialog.alert({
          message: "评论信息不能为空",
        }).then(() => {
          this.isPinlunShow = false;
          this.isDianzanShow = true;
        });
        return;
      }
      Toast.loading({
        message: "评论发布中...",
        forbidClick: true,
      });
      let params = qs.stringify({
        interactionid: this.$route.query.id,
        content: this.pinlunContent,
      });
      this.$axios
        .post("appinteraction/user/appInteraction/saveCommnent", params)
        .then((res) => {
          if (res.data.result !== 1) {
            Dialog.alert({
              message: res.data.reason,
            }).then(() => {
              return;
            });
          }
          if (res.data.result == 1) {
            this.isDianzanShow = true;
            this.isPinlunShow = false;
            this.pinlunContent = "";
            location.reload();
            this.$toast("已添加评论");

            return;
          }
        })
        .catch((err) => {
          console.error(err);
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
          return;
        });
    },
    noShare() {
      this.isShowShare = false;
    },
    goMyzone() {
      this.$router.push("/myzone");
    },
    showDianzan() {
      this.isDianzanShow = true;
    },
    goPinlun() {
      this.isDianzanShow = false;
      this.isPinlunShow = true;
      this.pinlunContent = "";
    },
    goDianzan() {
      this.isPinlunShow = false;
      this.isDianzanShow = true;
    },
    showShare() {
      this.isShowShare = true;
    },
    getContent() {
      let reg = /^(\d{3})\d{4}(\d{4})$/;
      let params = qs.stringify({
        id: this.$route.query.id,
      });
      this.$axios
        .post(
          "appinteraction/user/appInteraction/getInteractionDetails",
          params
        )
        .then((res) => {
          console.log(res);
          if (res.data.result !== 1) {
            Dialog.alert({
              message: res.data.reason,
            }).then(() => {});
            return;
          }
          if (res.data.result === 1) {
            console.log(res);
            this.inContent = res.data;
            res.data.interaction.createtime = this.getYMDHMS(
              res.data.interaction.createtime
            );
            this.interaction = res.data.interaction;

            res.data.commentList.forEach((item) => {
              item.createtime = this.setDate(item.createtime);
              item.phone = item.phone.replace(reg, "$1****$2");
              if (item.content == "") {
                item.content = "";
              }
              this.commentList.push(item);
            });
          }
        })
        .catch((err) => {
          console.error(err);
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
          return;
        });
    },
    getYMDHMS(timestamp) {
      let time = new Date(timestamp);
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let date = time.getDate();
      let hours = time.getHours();
      let minute = time.getMinutes();
      let second = time.getSeconds();

      if (month < 10) {
        month = "0" + month;
      }
      if (date < 10) {
        date = "0" + date;
      }
      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minute < 10) {
        minute = "0" + minute;
      }
      if (second < 10) {
        second = "0" + second;
      }
      return year + "-" + month + "-" + date;
    },
    setDate(timespan) {
      let dateTime = new Date(timespan); // 将传进来的字符串或者毫秒转为标准时间
      let year = dateTime.getFullYear();
      let month = dateTime.getMonth() + 1;
      let day = dateTime.getDate();
      let millisecond = dateTime.getTime(); // 将当前编辑的时间转换为毫秒
      let now = new Date(); // 获取本机当前的时间
      let nowyear = now.getFullYear();
      let nowNew = now.getTime(); // 将本机的时间转换为毫秒
      let milliseconds = 0;
      let timeSpanStr = "";
      milliseconds = nowNew - millisecond;
      if (milliseconds <= 1000 * 60 * 1) {
        // 小于一分钟展示为刚刚
        timeSpanStr = "刚刚";
      } else if (
        1000 * 60 * 1 < milliseconds &&
        milliseconds <= 1000 * 60 * 60
      ) {
        // 大于一分钟小于一小时展示为分钟
        timeSpanStr = Math.round(milliseconds / (1000 * 60)) + "分钟前";
      } else if (
        1000 * 60 * 60 * 1 < milliseconds &&
        milliseconds <= 1000 * 60 * 60 * 24
      ) {
        // 大于一小时小于一天展示为小时
        timeSpanStr = Math.round(milliseconds / (1000 * 60 * 60)) + "小时前";
      } else if (
        1000 * 60 * 60 * 24 < milliseconds &&
        milliseconds <= 1000 * 60 * 60 * 24 * 3
      ) {
        // 大于一天小于三天展示为天
        timeSpanStr = Math.round(milliseconds / (1000 * 60 * 60 * 24)) + "天前";
      } else if (year > nowyear) {
        timeSpanStr = month + "-" + day;
      } else {
        timeSpanStr = year + "-" + month + "-" + day;
      }
      return timeSpanStr;
    },
    dianzan(isFabulous, isDianzan) {
      if (isFabulous == 0 || isDianzan) {
        let params = qs.stringify({
          interactionid: this.$route.query.id,
        });
        this.$axios
          .post("appinteraction/user/appInteraction/saveFabulous", params)
          .then((res) => {
            console.log(res);
            if (res.data.result !== 1) {
              Dialog.alert({
                message: res.data.reason,
              }).then(() => {});
              return;
            }
            if (res.data.result === 1) {
              location.reload();
              this.$toast("点赞成功");
              return;
            }
          })
          .catch((err) => {
            console.error(err);
            Dialog.alert({
              message: "接口调用失败",
            }).then(() => {});
            return;
          });
      }
      if (isFabulous == 1) {
        let params = qs.stringify({
          interactionid: this.$route.query.id,
        });

        this.$axios
          .post("appinteraction/user/appInteraction/delFabulous", params)
          .then((res) => {
            console.log(res);
            if (res.data.result !== 1) {
              Dialog.alert({
                message: res.data.reason,
              }).then(() => {});
              return;
            }
            if (res.data.result === 1) {
              location.reload();
              this.$toast("取消点赞");
              return;
            }
          })
          .catch((err) => {
            console.error(err);
            Dialog.alert({
              message: "接口调用失败",
            }).then(() => {});
            return;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-indicator {
  position: absolute;
  right: 0.625rem;
  bottom: 0.625rem;
  padding: 0.25rem 0.625rem;
  font-size: 1.5rem;
  background: rgba(0, 0, 0, 0.1);
}

.xiangqing {
  background-color: #fff;
  padding-top: 2.625rem;
}
.xiangqingContainer {
  .content1 {
    padding: 0 2rem 1.75rem 2rem;
    .picLunbo {
      img {
        width: 42.875rem;
        height: 57.125rem;
      }
    }
    .word {
      margin-top: 1.75rem;
      font-size: 1.75rem;
      color: #19212a;
    }
    .addr {
      margin-top: 1.75rem;
      width: 73%;

      padding: 1.125rem 1.5rem;
      display: flex;
      align-items: center;
      background: #f7f7f7;
      border-radius: 2.25rem;
      .addrWord {
        font-size: 1.625rem;
        color: #878787;
        margin-left: 1rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .date {
      margin-top: 2.375rem;
      font-size: 1.5rem;
      color: #878787;
    }
  }
  .fenge {
    width: 100%;
    height: 1.25rem;
    background: #eef4f6;
  }
  .content2 {
    padding: 1.75rem 2rem 0 2rem;
    margin-bottom: 8rem;
    .Seldianzan {
      display: flex;
      align-items: center;
      .pinlun {
        height: 2.875rem;
        margin-right: 5.875rem;
        font-size: 1.75rem;
        color: #878787;
      }
      .active {
        color: #19212a;
        font-weight: bold;
        font-size: 1.875rem;
      }
      .xiahuaxian {
        height: 0.5rem;
        background: #338989;
        border-radius: 0.5rem;
        margin-top: 0.75rem;
      }
    }
    .noPinlun {
      padding: 5.25rem 0 7.75rem 0;
      img {
        width: 14.875rem;
        height: 10rem;
      }
      .nopinlunimg {
        display: flex;
        justify-content: center;
      }
      .word {
        text-align: center;
        margin-top: 1.875rem;
        color: #555555;
        font-size: 1.75rem;
        line-height: 2.625rem;
        font-weight: 500;
      }
    }
    .pinlunList {
      margin-top: 2.875rem;
      .touxiang {
        img {
          width: 5rem;
        }
      }
      .InPinlunList {
        display: flex;
        margin-bottom: 3.625rem;

        .listContent {
          width: 100%;
          border-bottom: 1px solid #eaeaea;
          padding-bottom: 1.5rem;
          margin-left: 2.125rem;
          .xinxi {
            display: flex;
            justify-content: space-between;
            .phoneNum {
              font-size: 1.625rem;
              color: #555555;
              white-space: nowrap;
            }

            .date {
              color: #b0b0b0;
              margin-left: 18.75rem;
              font-size: 1.5rem;
              white-space: nowrap;
            }
          }
          .pinlunContent {
            margin-top: 1.375rem;
            font-size: 1.875rem;
            color: #383838;
          }
        }
      }
    }
  }
  .dibu1 {
    width: 100%;
    // height: 6.375rem;
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: #fff;
    border-top: 1px solid #eaeaea;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.25rem 1.875rem;
    .shurukuang {
      display: flex;
      align-items: center;
      width: 68%;
      height: 4rem;
      background: #f7f8f8;
      border-radius: 2416px;
      padding-left: 2.125rem;
      img {
        width: 2.125rem;
      }
      .word {
        color: #888888;
        font-size: 1.75rem;
        margin-left: 1.25rem;
      }
    }
    .dibuDianzan {
      display: flex;

      align-items: center;
      img {
        width: 2.5rem;
        height: 2.5rem;
      }
      .dianzanWord {
        color: #555555;
        font-size: 1.5rem;
        white-space: nowrap;
        margin-left: 0.75rem;
      }
    }
    .share {
      img {
        width: 2.75rem;
      }
    }
  }
  .dibu2 {
    display: flex;
    align-items: center;

    padding: 1.5rem 2.375rem 1.25rem 2rem;
    input {
      width: 36.125rem;
      height: 5.5rem;
      border: none;
      background: #f3f5f7;
      border-radius: 3rem;
      padding-left: 2.5rem;
      font-size: 2rem;
      color: #878787;
    }
    .fabuWord {
      color: #338989;
      font-weight: bold;
      font-size: 2rem;
      margin-left: 2.375rem;
      white-space: nowrap;
    }
  }
}
.shareWayList {
  padding: 0 1rem 1.5rem 1rem;
  display: flex;
  flex-wrap: wrap;
  .everyShare {
    width: 25%;
    display: flex;
    justify-content: center;
    margin-top: 3.125rem;
    .shareIcon {
      img {
        width: 6.5rem;
      }
    }
    .shareName {
      color: #555555;
      font-size: 1.625rem;
      margin-top: 1rem;
      text-align: center;
    }
  }
}
.fenge {
  width: 100%;
  height: 1.25rem;
  background: #eef4f6;
}
.dibuQuxiao {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 6.375rem;
  .word {
    color: #19212a;
    font-size: 2rem;
  }
}
</style>
<style lang="scss" scoped>
.picLunbo ::v-deep .van-swipe .van-swipe__track .van-swipe-item {
  width: 42.875rem !important;
  height: 57.125rem;

  img {
    border-radius: 1rem;
  }
}
.picLunbo ::v-deep .custom-indicator {
  position: absolute;
  right: 2rem;
  bottom: 2.375rem;
  padding: 0.25rem 1.5rem;
  color: #ffffff;
  background: rgba(0, 0, 0, 0.85);
  border-radius: 1.375rem;
}
</style>
